import { generatePath } from 'react-router-dom';
import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_SOLUTION_USERS,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_USERS,
} from '../constants';
import { mapSolutionUsersData } from './utils';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_SOLUTION_USERS, { solutionId }),
  }).then(mapSolutionUsersData);

const solutionUsersSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_USERS,
});

export default solutionUsersSlice;
